
const state = {
  isDot: false
}
const getters = {

}
const mutations = {

  timelyMsg (state, data) {
    state.isDot = data;
  },
}

const actions = {

}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/modules/user-center/news/vuex.js